import { render, staticRenderFns } from "./ToApp.vue?vue&type=template&id=ffbcab86&scoped=true"
import script from "./ToApp.vue?vue&type=script&lang=js"
export * from "./ToApp.vue?vue&type=script&lang=js"
import style0 from "./ToApp.vue?vue&type=style&index=0&id=ffbcab86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbcab86",
  null
  
)

export default component.exports